export function normalizeAgeType(value) {
  const ageType = Number(value);
  return Number.isInteger(ageType) ? ageType : -1;
}

export function getAgeTypeLabel(value) {
  const ageType = normalizeAgeType(value);

  switch (ageType) {
    case 0:
      return "Exento";
    case 1:
      return "Infantil";
    case 2:
      return "Juvenil";
    case 3:
      return "Adulto";
    case 4:
      return "Temporal";
    default:
      return "Desconocido";
  }
}
